module.exports = __webpack_public_path__ + "img/icon_keyboard_active.08d54898.svg";